import { useTranslation } from 'react-i18next';

export default function SessionMapLegend({ variant = 'session' }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center gap-4 sm:gap-6 text-sm">
      <div className="flex items-center gap-2">
        <div className="w-4 h-4 rounded bg-red-100 dark:bg-red-900/30 border-2 border-red-200 dark:border-red-800" />
        <span className="text-gray-600 dark:text-gray-400">{t('sessionMap.unanswered')}</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-4 h-4 rounded bg-yellow-100 dark:bg-yellow-900/30 border-2 border-yellow-200 dark:border-yellow-800" />
        <span className="text-gray-600 dark:text-gray-400">{t('common.inProgress')}</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-4 h-4 rounded bg-green-100 dark:bg-green-900/30 border-2 border-green-200 dark:border-green-800" />
        <span className="text-gray-600 dark:text-gray-400">{variant === 'homework' ? t('feedback.correctMark') : t('sessionMap.answered')}</span>
      </div>
      {variant === 'homework' && (
        <>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded bg-red-50 dark:bg-red-900/20 border-2 border-red-300 dark:border-red-700" />
            <span className="text-gray-600 dark:text-gray-400">Incorrect</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="relative w-4 h-4 rounded bg-gray-100 dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 ring-2 ring-amber-400 ring-offset-1">
              <div className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-amber-400 rounded-full" />
            </div>
            <span className="text-gray-600 dark:text-gray-400">Needs Review</span>
          </div>
        </>
      )}
      {variant === 'session' && (
        <div className="flex items-center gap-2">
          <div className="relative w-4 h-4 rounded bg-gray-100 dark:bg-gray-800 border-2 border-gray-200 dark:border-gray-700 ring-2 ring-blue-500 ring-offset-1">
            <div className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-blue-500 rounded-full animate-pulse" />
          </div>
          <span className="text-gray-600 dark:text-gray-400">{t('sessionMap.currentlyViewing')}</span>
        </div>
      )}
    </div>
  );
}
